import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";

import Home from "./pages/Home/Home"; 
import AppLoader from "./components/shared/AppLoader/AppLoader";
import useAppLoader from "./hooks/useAppLoader";
import AllSolution from './pages/AllSolution/AllSolution';
import Academy from './pages/Academy/Academy';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import AllProjects from './pages/AllProjects/AllProjects';
import ContactUs from './pages/ContactUs/ContactUs';
import Careers from './pages/Careers/Careers';
import CareerDetails from './pages/CareerDetails/CareerDetails';
import CareerApply from './pages/CareerApply/CareerApply';
import Blog from './pages/Blog/Blog';
import BlogDetails from './pages/BlogDetails/BlogDetails';
import ProjectDetails from './pages/ProjectDetails/ProjectDetails';
import Terms from './pages/Terms/Terms';
import Downloads from './pages/Downloads/Downloads';
import SolutionDetails from './pages/AllSolution/SolutionDetails';
import AllProducts from './pages/AllProducts/AllProducts';
import Boards from './pages/Boards/Boards';
import BoardsDetail from './pages/Boards/BoardsDetail';
import MetalDetail from './pages/Metal/MetalDetail';
import SectorDetail from './pages/Sectors/SectorDetail';
import Estimator from './pages/Estimator/Estimator';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import ProtectedRoute from './routes/ProtectedRoute';
import NotFound from './pages/NotFound/NotFound';
import AllSectors from './pages/AllSectors/AllSectors';
import Accessories from './pages/Accessories/Accessories';
import DrywallMetalFrames from './pages/DrywallMetalFrames/DrywallMetalFrames';
import DrywallMetalFrameDetail from './pages/DrywallMetalFrames/DrywallMetalFrameDetail';
import CeilingMetalFrames from './pages/CeilingMetalFrames/CeilingMetalFrames';
import CeilingMetalFrameDetail from './pages/CeilingMetalFrames/CeilingMetalFrameDetail';
import CourseDetail from './pages/CourseDetail/CourseDetail';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const { pathname } = useLocation();
  const { isLoaderVisible, isLoaderFinishing } = useAppLoader(pathname);
  return (
    <div className="App">
      <ScrollToTop />
      {isLoaderVisible && <AppLoader isFinishing={isLoaderFinishing} />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/allsolutions" element={<AllSolution />} />
        <Route path="/academy" element={<Academy />} />
        <Route path="/academy/courses/:courseId" element={<CourseDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/allprojects" element={<AllProjects />} />
        <Route path="/allprojects/:projectId" element={<ProjectDetails />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/terms" element={<Terms />} />
        <Route
          path="/solutiondetails"
          element={<Navigate to="/solutiondetails/exterior-system" replace />}
        />
        <Route path="/solutiondetails/:solutionSlug" element={<SolutionDetails />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/blog/:postId" element={<BlogDetails />} />
        <Route path="/careers/:jobId" element={<CareerDetails />} />
        <Route path="/careers/:jobId/apply" element={<CareerApply />} />
        <Route path="/products" element={<AllProducts />} />
        <Route path="/products/boards/:boardId" element={<BoardsDetail />} />
        <Route path="/products/boards" element={<Boards />} />
        <Route path="/products/accessories/:metalId" element={<MetalDetail />} />
        <Route path="/products/metal/:metalId" element={<MetalDetail />} />
        <Route path="/sectors" element={<AllSectors/>} />
        <Route path="/sectors/:sectorSlug" element={<SectorDetail />} />
        <Route path="/estimator" element={<Estimator />} />
        <Route path="/accessories" element={<Accessories />} />
        <Route path="/products/drywall-metal-frame" element={<DrywallMetalFrames />} />
        <Route path="/products/drywall-metal-frame/:frameId" element={<DrywallMetalFrameDetail />} />
        <Route path="/products/ceiling-metal-frame" element={<CeilingMetalFrames />} />
        <Route path="/products/ceiling-metal-frame/:frameId" element={<CeilingMetalFrameDetail />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;